<div id="commentsModalContainer">
  <button class="btn btn-tertiary srs-save-btn" matBadge="{{notifications}}" matBadgeColor="warn" (click)="openDialog()"><i class="fas fa-comments"></i></button>
</div>
